import { CardContent, Grid, Paper } from '@material-ui/core';
import React from 'react';
import SampleDevelopmentNlFinishingFront from './SampleDevelopmentNlFinishingFront';
import SampleDevelopmentNlFinishingBack from './SampleDevelopmentNlFinishingBack';

interface SamDevNlFinishingProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlFinishing: React.FC<SamDevNlFinishingProps> = (props) => {
  const { isCrtLocked = false } = props;
  return (
    <Paper variant="outlined">
      <CardContent>
        <Grid container spacing={1} direction="row" justifyContent="flex-start">
          <Grid item xs={12} sm={6} container>
            <SampleDevelopmentNlFinishingFront isCrtLocked={isCrtLocked} />
          </Grid>
          <Grid item xs={12} sm={6} container>
            <SampleDevelopmentNlFinishingBack isCrtLocked={isCrtLocked} />
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default SampleDevelopmentNlFinishing;
